<template>
  <ym-button class="header-back-btn-component"
             icon="back"
             :style="buttonStyle"
             @click="handleClickBack"
  >
    {{ text }}
  </ym-button>
</template>

<script>
  import { Button } from 'ym-mint-ui';

  export default {
    name: 'HeaderBackBtn',
    components: {
      'ym-button': Button,
    },
    props: {
      text: {
        type: String,
      },
      buttonStyle: {
        type: [String, Object],
      },
    },
    methods: {
      handleClickBack() {
        const { meta } = this.$route || {};
        const { back } = meta;
        if (back) {
          this.$router.replace(back);
          return;
        }
        const { history, location } = window;
        const { length } = history;
        // 当前路径为第一页，则回到首页
        if (length < 2) {
          const { origin } = location;
          window.location.href = origin;
          return;
        }
        this.$router.go(-1);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .header-back-btn-component {
    background-color: transparent;
    border: 0;
    box-shadow: none;
    color: inherit;
    display: inline-block;
    padding: 0;
    font-size: @font-size-small;
  }
</style>
